import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import chevronBlack from '../../../../images/chevron-down-black.svg';
import minusIconWhite from '../../../../images/minus-icon-white.svg';
import plusIconWhite from '../../../../images/plus-icon-white.svg';
import chevronDownIconWhite from '../../../../images/chevron-down-white.svg';
import chevronUpIconWhite from '../../../../images/chevron-up-white.svg';
import Ctas from '../../../Core/Ctas';

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.5rem;
  text-align: center;
  p {
    padding-top: 0.5rem;
    font-size: 1.25rem;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2.5rem;
    p {
      padding-top: 0.5rem;
      font-size: 1.5rem;
    }
  }
`;

export const Heading = styled.h2`
  font-size: 2.5rem;
`;

export const Grid = styled.div`
  display: none;
  height: ${({ isGridOpen }) => (isGridOpen ? '100%' : '700px')};
  overflow: hidden;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-auto-columns: 1fr;
    grid-template-rows: repeat(10, min-content);
    margin: 2rem auto 0;
    gap: 0 1.5rem;
    padding: 0.5rem 2rem 0;
    max-width: ${({ noOfCards }) => `calc(64px + ( 410px * ${noOfCards}))`};
  }
  &.expanded {
    max-width: 100%;
  }
`;

export const MultiCardContainer = styled.div`
  background-color: ${themeGet('colors.white')};
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
  display: grid;
  grid-row: 1 / -1;
  grid-template-rows: subgrid;
  border-radius: 1.5rem 1.5rem 0 0;
`;

export const SingleCardContainer = styled.div`
  background-color: ${themeGet('colors.white')};
  display: flex;
  flex-direction: column;
  border-radius: 1.5rem;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
  max-width: 620px;
`;

export const AccordionButton = styled.button`
  background-color: ${themeGet('colors.surface-black')};
  border-radius: 0 0 1.5rem 1.5rem;
  height: 3rem;
  box-shadow: ${({ $isCardOpen }) =>
    $isCardOpen ? `none` : `0rem -3rem 5.5rem 1rem rgb(255 255 255)`};
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    grid-row: 1/-1;
  }
  &::after {
    content: ${({ $isCardOpen }) =>
      $isCardOpen ? `url(${minusIconWhite})` : `url(${plusIconWhite})`};
    position: relative;
  }
  &:hover,
  :focus {
    background-color: ${themeGet('colors.esso-red')};
  }

  &.red-theme {
    background-color: ${themeGet('colors.pc-red')};
    &::after {
      content: ${({ $isCardOpen }) =>
        $isCardOpen
          ? `url(${chevronUpIconWhite})`
          : `url(${chevronDownIconWhite})`};
      position: relative;
    }
  }
`;

export const StyledCtas = styled(Ctas)`
  margin-top: 3rem;
  display: flex;
`;

export const Dropdown = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  border-radius: 6px 6px 0px 0px;
  padding: 1rem 0 0.5rem;
  width: 100%;

  &:lang(fr) {
    padding: 10px 8px;
  }

  &::after {
    content: '';
    height: 6px;
    width: 6px;
    display: block;
    position: absolute;
    left: 100%;
    bottom: 0;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: none;
  }
`;

export const DropdownBtn = styled.button`
  display: flex;
  font-size: 1rem;
  line-height: 150%;
  border: 1px solid ${themeGet('colors.main-text')};
  border-radius: 2rem;
  padding: 0.5rem 1rem;
  max-width: 320px;
  width: 100%;
  justify-content: space-between;

  &::after {
    content: ${`url(${chevronBlack})`};
    position: relative;
    margin: 0 0 0 10px;
  }
`;

export const DropdownMenu = styled.div`
  z-index: 10;
  position: absolute;
  top: calc(100% - 1px);
  display: ${({ $isActive }) => ($isActive ? 'flex' : 'none')};
  flex-direction: column;
  align-items: start;
  background-color: ${themeGet('colors.white')};
  border-radius: 0.5rem;
  padding: 1.5rem 1.25rem;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  max-width: 320px;
  width: 100%;
`;

export const ListBtn = styled.button`
  display: flex;
  width: 100%;
  &:hover,
  :focus {
    background-color: ${themeGet('colors.light-border-grey')};
  }
  &.active {
    background-color: ${themeGet('colors.border-grey')};
  }
`;

export const MobileViewGrid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  overflow: hidden;
  padding: 0.5rem 1rem;
  row-gap: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: none;
  }

  &.single-card-view {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      display: flex;
    }
  }
`;

export const AccordianContainer = styled.div`
  display: none;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-auto-columns: 1fr;
    gap: 0 1.5rem;
    height: 3rem;
    padding: 0 2rem;
    position: inherit;
    margin: auto;
    max-width: ${({ noOfCards }) => `calc(64px + ( 410px * ${noOfCards}))`};
  }
  &.expanded {
    max-width: 100%;
  }
`;

export const CardCtaContainer = styled.div`
  display: none;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-auto-columns: 1fr;
    gap: 0 1.5rem;
    padding: 0 2rem;
    position: inherit;
    margin: auto;
  }
`;

export const CardCta = styled.button`
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    grid-row: 1/-1;
  }
`;

export const GridContainer = styled.div`
  &.hide-grid {
    display: none;
  }
`;

export const TabContainer = styled.div`
  display: none;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.single-card-view {
      display: flex;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
      margin: auto;
      max-width: 750px;
      border-radius: 3rem;
      padding: 15px 20px;
      margin-bottom: 3rem;
      justify-content: space-evenly;
    }
  }
`;

export const TabBtn = styled.button`
  &:hover,
  :focus {
    text-decoration: underline;
  }
  &.active {
    p {
      color: ${themeGet('colors.pc-red')};
      text-decoration: underline;
    }
  }
  &:not(:last-child) {
    border-right: 1px solid ${themeGet('colors.black')};
    padding-right: 15px;
  }
  &:not(:first-child) {
    padding-left: 15px;
  }
`;

export const TabBtnLabel = styled.p`
  font-size: 18px;
  font-weight: ${themeGet('fontWeights.medium')};
`;
